import styled from 'styled-components';

type TextProps = {
  color?: string;
  size?: string;
  fontStyle?: string;
  weight?: number | string;
  wordBreak?: string;
  margin?: string;
  lineHeight?: string;
  minHeight?: string;
  maxWidht?: string;
  family?: string;
  opacity?: number | string;
  transform?: string;
  align?: string;
  whiteSpace?: string;
  nowrap?: boolean;
  noPrint?: boolean;
};

export const Text = styled.span<TextProps>`
  color: ${props => props.theme.colors[props.color] || props.color};
  font-size: ${props => props.size || '14px'};
  font-style: ${props => props.fontStyle || 'normal'};
  font-weight: ${props => props.weight || 400};
  word-break: ${props => props.wordBreak || 'initial'};

  ${props => props.margin && `
    margin: ${props.margin};
  `};

  ${props => props.lineHeight && `
    line-height: ${props.lineHeight};
  `};

  ${props => props.minHeight && `
    min-height: ${props.minHeight};
  `};

  ${props => props.maxWidht && `
    max-width: ${props.maxWidht};
  `};

  ${props => props.family && `
    font-family: ${props.family};
  `};

  ${props => props.opacity && `
    opacity: ${props.opacity};
  `};

  ${props => props.transform && `
    text-transform: ${props.transform};
  `};

  ${props => props.align && `
    text-align: ${props.align};
  `};

  ${props => props.whiteSpace && `
    white-space: ${props.whiteSpace};
  `};

  ${props => props.nowrap && `
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  `};

  ${props => props.noPrint && `
    @media print {
      display: none;
    }
  `}
`;

export const TextLight = styled(Text).attrs({
  weight: 300,
})``;

export const TextMedium = styled(Text).attrs({
  weight: 500,
})``;

export const TextHeavy = styled(Text).attrs({
  weight: 600,
})``;

export const TextBold = styled(Text).attrs({
  weight: 700,
})``;

export const TextMuted = styled(Text).attrs({
  opacity: 0.4,
})``;

export const H100 = styled(TextBold).attrs({
  size: '2em',
})``;

export const H200 = styled(TextHeavy).attrs({
  size: '1.6em',
})``;

export const H300 = styled(TextMedium).attrs({
  size: '1.35em',
})``;

export const H400 = styled(TextMedium).attrs({
  size: '1.15em',
})``;

export const H500 = styled(TextMedium).attrs({
  size: '1.10em',
})``;

export const TextOverflowDots = styled(Text)`
  display: block;
  width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type BreadcrumbsProps = {
  active?: boolean;
  chevron?: boolean;
  clickable?: boolean;
};

export const TextBreadcrumbs = styled(Text)<BreadcrumbsProps>`
  color: ${props => (props.active ? props.theme.colors.link : '#757575')};
  font-size: 19px;
  font-weight: bold;
  line-height: 31px;

  ${props => props.clickable && `
    cursor: pointer;
    &:hover {
      color: ${props.theme.colors.link};
    }
  `};

  ${props => props.chevron && `
    &::after {
      content: "\f054";
      color: #989898;
      font-family: "Font Awesome 5 Free";
      font-size: 8px;
      line-height: 18px;
      vertical-align: 2px;
      margin-left: 10px;
      display: inline-block;
    }
  `};
`;
